export const staircaseConfig = {
    gameSlug: 'antisaccade',
    category: 'foudre_logique',
    variable: 'duration_ms',
    startValue: 250,
    minValue: 80,
    maxValue: 600,
    stepSizesByPhase: [80, 40, 20, 10],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 30,
    direction: 'up-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, cueDurationMs: 200, targetDurationMs: 200, label: 'Antisaccade découverte' };
    }
    if (level <= 20) {
        return { level, cueDurationMs: 170, targetDurationMs: 180, label: 'Inhibition installée' };
    }
    if (level <= 30) {
        return { level, cueDurationMs: 150, targetDurationMs: 160, label: 'Vitesse + contrôle' };
    }
    if (level <= 40) {
        return { level, cueDurationMs: 130, targetDurationMs: 140, label: 'Pression temporelle' };
    }
    return { level, cueDurationMs: 100, targetDurationMs: 120, label: 'Contrôle oculomoteur expert' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    fixationMs: 500,
    feedbackMs: 500,
    itiMs: 700,
    /** Fenêtre de réponse après onset du target (ms). */
    responseWindowMs: 1500,
};
export const paradigmMeta = {
    slug: 'antisaccade',
    paradigm: 'Antisaccade Task (Hallett 1978)',
    category: 'foudre_logique',
    goal: 'Inhibition saccadique : annuler le réflexe vers le cue, regarder du côté opposé.',
};
//# sourceMappingURL=params.js.map